export function pyRound(value, digits = 0) {
  if (typeof value !== "number" || !Number.isFinite(value)) return value;

  const d = digits == null ? 0 : Math.max(0, Math.trunc(Number(digits)) || 0);
  if (d > 100) return value;

  const rounded = Number(value.toFixed(d));

  const exact = Math.abs(value).toFixed(100);
  const point = exact.indexOf(".");
  const tail = exact.slice(point + 1 + d);
  if (!/^50*$/.test(tail)) return rounded;

  const truncatedStr = d === 0 ? exact.slice(0, point) : exact.slice(0, point + 1 + d);
  const lastDigit = Number(truncatedStr[truncatedStr.length - 1]);
  if (lastDigit % 2 === 0) {
    const truncated = Number(truncatedStr);
    return value < 0 ? -truncated : truncated;
  }
  return rounded;
}

export function pyFormatFixed(value, digits) {
  if (typeof value !== "number" || !Number.isFinite(value)) return String(value);
  const d = Math.max(0, Math.trunc(Number(digits)) || 0);
  return pyRound(value, d).toFixed(d);
}
